<template>
  <mt-popup v-model="hasNoticePopup" position="bottom" class="notice-popup">
    <div class="top-title">
      <div class="name s10 t1">往期回顾</div>
      <div class="close" @click="hasNoticePopup=false"></div>
    </div>
    <div
      class="record-wrap"
      v-for="(FirstItem,Firstindex) in previousList"
      :key="Firstindex"
    >
      <div class="title s6 t3 b2">{{monthArr[FirstItem.month-1]}}月</div>
      <div
        class="record"
        v-for="(item,index) in FirstItem.allData"
        :key="index"
      >
        <div
          class="item s8 t1 border-1px-b"
          @click="emitId(item.id)"
          :class="{'choose':item.id===fatherId}"
        >【{{dayjs(item.publishTime).format('MM.DD')}}】 {{item.title}}</div>
      </div>
    </div>
  </mt-popup>
</template>
<script>
import { Popup } from 'mint-ui'
import { History } from '@/api/user.js'
import dayjs from 'dayjs'
import appInfo from '@/assets/js/appInfo.js'
// import ym from '@/assets/js/ym.js'

export default {
  components: {
    'mt-popup': Popup
  },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    popupType: {
      type: String,
      default: 'popup'
    },
    fatherId: {}
  },
  data() {
    return {
      id: appInfo.getParam('id') || 0,
      previousList: [],
      monthArr: [
        '一',
        '二',
        '三',
        '四',
        '五',
        '六',
        '七',
        '八',
        '九',
        '十',
        '十一',
        '十二'
      ]
    }
  },
  computed: {
    hasNoticePopup: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  created() {
    this.History()
  },
  methods: {
    dayjs,
    emitId(id) {
      this.$emit('emitId', id)
    },
    async History() {
      const { result, detail } = await History(this.id)
      if (result.code === 0) {
        const list = detail.list

        // 处理按月份分类
        this.dealWithData(list)
      }
    },
    dealWithData(data) {
      const c = []
      const d = {}
      data.forEach(element => {
        if (!d[element.month]) {
          c.push({
            month: dayjs(element.publishTime).format('MM'),
            allData: [element]
          })
          d[element.month] = element
        } else {
          c.forEach(ele => {
            if (ele.month === dayjs(element.publishTime).format('MM')) {
              ele.allData.push(element)
            }
          })
        }
      })
      this.previousList = c
    }
  }
}
</script>
<style lang="scss" scoped>
.notice-popup {
  width: 100%;
  max-height: 800px;
  overflow-y: auto;
  .record-wrap {
    .choose {
      color: #0079ff;
    }
    .title {
      font-weight: 700;
      padding: 0 30px;
      height: 60px;
      display: flex;
      align-items: center;
    }
    .item {
      height: 110px;
      padding: 0 30px;
      display: flex;
      align-items: center;
    }
  }
  .top-title {
    position: relative;
    display: flex;
    height: 110px;
    justify-content: center;
    align-items: center;
    .name {
      font-weight: 700;
    }
  }
  .close {
    position: absolute;
    width: 30px;
    height: 30px;
    background: url('./images/close.png') no-repeat;
    background-size: cover;
    top: 40px;
    right: 36px;
  }
}
</style>
